import React from 'react';
import cm from 'classnames';
import styles from '../_input.module.scss';

interface Props {
  className?: string;
  children?: React.ReactNode;
}

const InputAlert: React.FC<Props> = (props: Props) => {
  const { className, children } = props;
  const finalClassName = [styles.InputAlert];
  if (className) finalClassName.push(className);
  return <p className={cm(finalClassName)}>{children}</p>;
};

export { InputAlert };
